module.exports = __webpack_public_path__ + "img/gsbank.a88cf496.png";